import { find } from 'lodash';
import { isVanWestendorpQuestionNode } from 'utils/nodeTypes';

export function getActiveNodeOrFallback(nodes = [], currentActiveId) {
  const containingGroup = nodes.find(({ questions: subNodes = [] } = {}) =>
    subNodes.find(({ refId }) => refId === currentActiveId),
  );
  // if the active node is inside a group node
  if (containingGroup) {
    return {
      refId: currentActiveId,
      groupRefId: containingGroup.refId,
    };
  }

  // if the active node is a group node or a standalone node
  const activeQuestion = nodes.find(
    ({ refId } = {}) => refId === currentActiveId,
  );
  if (activeQuestion) {
    return {
      refId: activeQuestion.refId,
      groupRefId: undefined,
    };
  }

  // if the active node is not found
  const firstQuestion = nodes[0];
  return {
    refId: firstQuestion?.refId,
    groupRefId: undefined,
  };
}

export function setActiveNode(state, action = { payload: {} }) {
  const { surveyDetailsExtended = {}, activeGroupId, activeQuestionId } = state;
  const { questions: nodes = [] } = surveyDetailsExtended;
  const { refId, groupRefId, isActiveNewNode } = action.payload;

  const newNodes = nodes.map((node) => {
    const newNode = {
      ...node,
    };

    // clear previous active subnode inside a group node
    if (node.refId === activeGroupId) {
      newNode.questions = newNode.questions.map((subNode) => ({
        ...subNode,
        scrollIntoView: null,
        ignoreScrollIfInViewport: null,
      }));
    }

    if (node.refId === activeQuestionId) {
      newNode.scrollIntoView = null;
      newNode.ignoreScrollIfInViewport = null;
    }

    if (node.refId === groupRefId) {
      const childTargetNode = find(node.questions, ['refId', refId]);
      if (isVanWestendorpQuestionNode(childTargetNode)) {
        return {
          ...newNode,
          scrollIntoView: null,
          ignoreScrollIfInViewport: null,
          questions: node.questions.map((subNode) => ({
            ...subNode,
            scrollIntoView: subNode.refId === refId ? Date.now() : null,
            isCollapsed: subNode.refId === refId ? false : subNode.isCollapsed,
            ignoreScrollIfInViewport: null,
          })),
        };
      }

      return {
        ...newNode,
        questions: node.questions.map((subNode) => ({
          ...subNode,
          scrollIntoView: subNode.refId === refId ? Date.now() : null,
          isCollapsed: subNode.refId === refId ? false : subNode.isCollapsed,
          ignoreScrollIfInViewport: null,
        })),
        scrollIntoView: null,
        ignoreScrollIfInViewport: null,
      };
    }

    if (node.refId === refId) {
      return {
        ...newNode,
        ignoreScrollIfInViewport: false,
        scrollIntoView: Date.now(),
        isCollapsed: false,
      };
    }

    return {
      ...newNode,
      scrollIntoView: null,
      ignoreScrollIfInViewport: null,
    };
  });

  return Object.assign({}, state, {
    activeQuestionId: refId,
    activeGroupId: groupRefId,
    isActiveNewNode,
    surveyDetailsExtended: {
      ...surveyDetailsExtended,
      questions: newNodes,
    },
  });
}
